import * as api from 'services/api';
import { addError } from 'actions/error';

export const createOrder = (body, token) => (dispatch) => {
  const options = token && typeof token === 'string' && token.length > 0 ? { token } : {};
  return api.post('orders', body, 'CREATE_ORDER', dispatch, {}, options).catch((error) => {
    dispatch(addError(new Error('CREATE_ORDER_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });
};

export const startPayment = (id, orderToken) => (dispatch) => {
  const options = orderToken && typeof orderToken === 'string' && orderToken.length > 0 ? { orderToken } : {};
  return api.post(`orders/${id}/create-invoice`, {}, 'START_PAYMENT', dispatch, {}, options).catch((error) => {
    dispatch(addError(new Error('START_PAYMENT_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });
};

export const getOrders = () => (dispatch) =>
  api.get('orders', 'CHECK_ORDERS_INFO', dispatch).catch((error) => {
    dispatch(addError(new Error('CHECK_ORDERS_INFO_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });

export const getOrder = (id) => (dispatch) =>
  api.get(`orders/${id}`, 'CHECK_ORDER_INFO', dispatch).catch((error) => {
    dispatch(addError(new Error('CHECK_ORDER_INFO_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });

export const checkPaymentStatus = (id) => (dispatch) =>
  api.put(`orders/${id}/update-invoice`, {}, 'CHECK_PAYMENT_STATUS', dispatch).catch((error) => {
    dispatch(addError(new Error('CHECK_PAYMENT_STATUS_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });
